import HistoryIcon from '@mui/icons-material/History';
import { Dialog, IconButton } from '@mui/material';
import { APPROVAL_TYPES, COMITEE_TYPES } from 'lib/api/approvals/types';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { showEntityRecord } from 'lib/functions/utils';
import MultiChatWindowContainer from 'pages/Finance/Components/Financing/common/chat';
import Comittee from 'pages/Finance/Components/Financing/common/Comittee';
import { ComiteeTabProvider } from 'pages/Finance/Components/Financing/common/Comittee/ComiteeTabProvider';
import FilesDialog from 'pages/Finance/Components/Financing/common/filesView';
import RiskReviews from 'pages/Finance/Components/Financing/common/Risk';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import ActiveDocuments from './components/ActiveDocuments';
import Summary from './components/Summary';

const ShoppingDialogRecieved = (props: any) => {
  const {
    shoppingCartType,
    openShoppingCart,
    setOpenShoppingCart,
    setUp,
    openRequest,
    executiveCreating,
    handleDetails,
  } = props;
  if (!openRequest) return null;
  const dispatch = useDispatch();
  const [openFiles, setOpenFiles] = useState(false);

  const comiteeTabInfo = {
    requestType: APPROVAL_TYPES.CREDIT_LINE,
    comiteeType: COMITEE_TYPES.RISK,
    requestId: openRequest.id,
    comiteeId: openRequest.comiteeId,
    canEdit: ['Asignada', 'Rechazada'].includes(openRequest.status),
    isRejected: openRequest.status === 'Rechazada',
    isActive: openRequest.status === 'Activa',
    refreshRequest: setUp,
  };

  const handleOpenEntityRecord = () => {
    showEntityRecord(dispatch, {
      type: 'CreditLine',
      id: openRequest.id,
    });
  };

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <Summary
          shoppingCartType={shoppingCartType}
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          setUp={setUp}
          openRequest={openRequest}
          handleDetails={handleDetails}
        />
      ),
    },
    {
      index: 1,
      label: 'Aprobación',
      disabled: ['Revisada', 'No solicitada', 'Validando'].includes(
        openRequest?.status,
      ),
      component: (
        <ComiteeTabProvider info={comiteeTabInfo}>
          <Comittee />
        </ComiteeTabProvider>
      ),
      path: 'recieved',
    },
    {
      index: 1,
      label: 'Activo',
      component: (
        <ActiveDocuments
          requestType="creditLine"
          request={openRequest}
          businessIdentifier={openRequest?.businessIdentifier}
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    {
      index: 2,
      label: 'Riesgo',
      component: (
        <div>
          <RiskReviews
            item={openRequest}
            requestTypes={['creditLine', 'creditLine-payers']}
          />
        </div>
      ),
      path: 'recieved',
    },
    {
      index: 3,
      label: 'Archivos',
      component: (
        <FilesDialog
          openRequest={openRequest}
          openFiles={openFiles}
          setOpenFiles={setOpenFiles}
          executiveCreating={executiveCreating}
          requestType="creditLine"
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    {
      index: 4,
      label: 'Chat',
      component: (
        <MultiChatWindowContainer
          selectedRequest={openRequest}
          requestType="creditLine"
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
  ];

  if (openRequest && openRequest.status === 'REJECTED') {
    tabs.pop();
  }

  if (executiveCreating) {
    tabs.pop();
  }

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={openShoppingCart}
      onClose={() => setOpenShoppingCart(false)}
    >
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={
            !executiveCreating ? `Línea #${openRequest?.id}` : 'Nueva solicitud'
          }
          record={
            openRequest.id && (
              <IconButton
                onClick={handleOpenEntityRecord}
                size="small"
                style={{ marginRight: 2 }}
                title="Ver historial de la entidad"
              >
                <HistoryIcon />
              </IconButton>
            )
          }
          startValue={0}
          tabs={tabs}
          updater={() => {}}
          context={openRequest?.businessName}
        />
      </div>
    </Dialog>
  );
};

export default ShoppingDialogRecieved;
